import React, { useEffect } from 'react'
import { useState, useContext, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { auth, googleProvider } from '../../config/firebase'
import { doc, getDoc } from "firebase/firestore";
import { db } from '../../config/firebase';
import ReactGA from "react-ga4";

import { FcGoogle } from "react-icons/fc";
import { PiIdentificationCardLight } from "react-icons/pi";
import { HiOutlineIdentification } from "react-icons/hi2";
import { RiLockPasswordLine } from "react-icons/ri";

import Spinner from '../../components/Loading/TailSpin';
import useOutsideCloser from '../../custom hooks/clickOutsideCloser';
import Footer from '../../components/footer/Footer';
import saycryptLogo from "../../assets/img/Saycrypt_Logo.png"
import { TncContent } from './TncContent';

function SignIn() {
  const navigate = useNavigate();
  const location = useLocation();
  const tncWrapperRef = useRef(null);

  const [cookies, setCookie] = useCookies(['GuruAccessKey']);
  const [userId, setUid] = useState("");
  const [password, setPassword] = useState("")
  const [isLoading, setIsLoading] = useState(false)

  const [showTnCPopup, setShowTnCPopup] = useState(false);
  useOutsideCloser(tncWrapperRef, setShowTnCPopup)


  const fetchUserDetail = async () => {
    setIsLoading(true);

    try {
      const docRef = doc(db, "users", userId);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const userData = docSnap.data();
        if (password === userData.password) {

          if (userData.accessLevel === 1) {
            setCookie("GuruAccessKey", "1q2w3e4r");
            localStorage.setItem("uid", userId);
            localStorage.setItem("displayName", userData.displayName);
            sendAnalytics("Successful Sign In");
            navigate("/GURU/manage-users/");
          }
          else {
            localStorage.setItem("uid", userId);
            localStorage.setItem("displayName", userData.displayName);
            sendAnalytics("Successful Sign In");
            navigate("/G");
          }
        } else {
          sendAnalytics("Wrong Password");
        }
        // console.log("Document data:", docSnap.data());
      } else {
        sendAnalytics("Wrong UID");
        // console.log("No such document!");
      }

    } catch (err) {
      console.error(err);
    }
    setIsLoading(false);
  };

  const handleSignIn = () => {
    if (userId !== "" && password !== "")
      fetchUserDetail()
  }


  const sendAnalytics = (status) => {
    ReactGA.event({
      category: "Sign In",
      action: status,
    });
  }
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: "Sign In" })
  }, [])

  if (!isLoading)
    return (
      <div className='relative bg-lightPrimary w-full h-full flex flex-col items-center justify-center p-6'>

        <img className='absolute top-[45px] left-0 right-0 mx-auto ' src={saycryptLogo} alt="logo" width={200} />

        <div className="w-full mt-[70px] md:w-[420px] p-9 bg-lightPrimary flex flex-col items-center rounded-xl ">

          <div className="w-full grid grid-cols-1 gap-4">

            <div className="flex justify-start w-full">
              <div className="border border-gray-300 bg-white text-gray-700 dark:bg-navy-900 dark:text-white z-1 flex h-[40px] md:h-[42px] w-full flex-grow items-left justify-start gap-2 rounded-xl px-2.5 py-2.5 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:flex-grow-0 md:gap-1 xl:gap-2 w-full">
                <div className="flex h-full w-full items-center font-normal ">
                  <PiIdentificationCardLight
                    className="h-4 w-4 text-gray-400 hover:text-headPrimary cursor-pointer dark:text-white" />
                  <input
                    onChange={(e) => {
                      setUid((e.target.value))
                    }}
                    value={userId}
                    type="text"
                    placeholder="ID"
                    className="block ml-0 px-2 h-auto w-full bg-white text-lg text-gray-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white"
                  />
                </div>

              </div>
            </div>

            <div className="flex justify-start w-full">
              <div className="border border-gray-300 bg-white text-gray-700 dark:bg-navy-900 dark:text-white z-1 flex h-[40px] md:h-[42px] w-full flex-grow items-left justify-start gap-2 rounded-xl px-2.5 py-2.5 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:flex-grow-0 md:gap-1 xl:gap-2 w-full">
                <div className="flex h-full w-full items-center font-normal ">
                  <RiLockPasswordLine
                    className="h-4 w-4 text-gray-400 hover:text-headPrimary cursor-pointer dark:text-white" />
                  <input
                    onChange={(e) => {
                      setPassword((e.target.value))
                    }}
                    value={password}
                    type="password"
                    placeholder="Password"
                    className="block ml-0 px-2 h-auto w-full bg-white text-lg text-gray-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white"
                  />
                </div>

              </div>
            </div>

          </div>


          <button
            onClick={handleSignIn}
            className=" mt-10 flex items-center justify-center py-2 w-[100%] bg-white rounded-xl border border-headPrimary
            headPrimary text-2xl font-semibold text-headPrimary hover:text-white hover:bg-headPrimary shadow-md hover:shadow-lg hover:border-[#40cb7b] hover:font-bold">
            Sign In
          </button>

        </div>

        {showTnCPopup &&
          <div style={{ "backgroundColor": "rgba(0, 0, 0, 0.8)" }}
            className="fixed inset-0 z-50 flex items-center justify-center outline-none focus:outline-none">
            <div className="relative my-6 mx-auto w-fit">

              <div ref={tncWrapperRef} className="relative flex w-[90vw] h-[90vh] sm:w-[80vw] sm:h-[85vh] p-6 pt-4 sm:p-10 sm:pt-7 flex-col justify-start rounded-xl bg-white shadow-lg outline-none dark:bg-navy-800 focus:outline-none">

                <button
                  onClick={() => {
                    setShowTnCPopup(false)
                  }}
                  type="button"
                  className="bg-transparent absolute absolute top-0 right-0 h-fit w-fit p-2 items-center justify-center rounded-xl text-sm text-gray-400 ms-auto hover:bg-gray-200 hover:text-neuGray dark:hover:bg-gray-600 dark:hover:text-white"
                  data-modal-hide="static-modal"
                >
                  <svg
                    className="h-3 w-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 14"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                    />
                  </svg>
                  <span className="sr-only">Close modal</span>
                </button>

                <div className="text-2xl font-semibold text-center text-headPrimary"> T&C with Privacy & Data Policy </div>

                <div className='w-full h-[calc(100%-30px)] overflow-y-auto py-5 px-1 flex flex-col text-base text-gray-600' >

                  {TncContent.map((item) => (
                    <div className="flex flex-col pb-5">
                      <div className="font-semibold mb-1">{item.name}</div>
                      <div className="font-normal  text-justify">{item.desc}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        }

        <div className="absolute bottom-5 left-0 right-0 text-center text-3xs font-normal text-gray-300">By Signing In, I Understand, Accept & Agree all the
          <span onClick={() => { setShowTnCPopup(true) }} className='hover:text-our-600 cursor-pointer'> T&C</span> with Privacy & Data Policy...</div>

        <Footer />
      </div>
    )

  else return (<Spinner />)
}

export default SignIn